<template>
    <div>
        The requested page was not found, or you do not have access to it.
    </div>
</template>

<script>

export default {
    name: 'NotFound',
};
</script>